import { store } from '../../redux/store';
import * as translations from '../../translations';

const TlnString = key => {
  const { activeLanguage } = store.getState().Languages;
  const activeTranslations = translations[activeLanguage];

  return activeTranslations[key] ? activeTranslations[key] : key;
};
export default TlnString;